import { Component, Vue } from 'vue-property-decorator';
import { getToday } from '@/utils/dateUtils';
@Component
export default class GroupGridsExcelDown extends Vue {
  public excelDownInfo: any = {
    fileName: 'group_list_' + getToday(),
    columns: {
      name: '권한그룹명',
      description: '권한그룹설명',
      adminCount: '권한보유자',
      permitsPrivateInformation: '개인정보 목록조회',
      allowsMarketingDirection: '상품담당자',
      creatorName: '등록자',
      creationDateTime: '등록일시',
      modifierName: '최종수정자 ',
      modificationDateTime: '최종수정일시'
    },
    formatters: {
      name: (data: any): void => {
        if (data.value) {
          return data.value
        }
      },
      description: (data: any): void => {
        if (data.value) {
          return data.value
        } else {
          return '' as any
        }
      },
      adminCount: (data: any): void => {
        if (data.value != 0) {
          return data.value
        } else {
          return 0 as any
        }
      },
      permitsPrivateInformation: (data: any): void => {
        if (data.value) {
          return 'Y' as any
        } else {
          return 'N' as any
        }
      },
      allowsMarketingDirection: (data: any): void => {
        if (data.value) {
          return 'Y' as any
        } else {
          return 'N' as any
        }
      },
      creatorName: (data: any): void => {
        if (data.value) {
          return data.value
        }
      },
      creationDateTime: (data: any): void => {
        if (data.value) {
          return data.value
        }
      },
      modifierName: (data: any): void => {
        if (data.value) {
          return data.value
        }
      },
      modificationDateTime: (data: any): void => {
        if (data.value) {
          return data.value
        }
      }
    }
  }
}